// Converted to lazy loading
const pointOfSalesIndex = () => import('@/pages/pointOfSales/pointOfSales/index.vue')
const pointOfSalesForm = () => import('@/pages/pointOfSales/pointOfSales/form.vue')

const pointOfSalesSessionIndex = () => import('@/pages/pointOfSales/pointOfSalesSessions/index.vue')
// import pointOfSalesSessionForm from '@/pages/pointOfSales/pointOfSalesSessions/form.vue'
const pointOfSalesSessionShow = () => import('@/pages/pointOfSales/pointOfSalesSessions/show.vue')

const pointOfSalesShow = () => import('@/pages/pointOfSales/salesApp/index.vue')
const pointOfSalesInvoices = () => import('@/pages/pointOfSales/salesApp/invoices.vue')
const pointOfSalesExpenses = () => import('@/pages/pointOfSales/salesApp/expenses.vue')
const pointOfSalesShipping = () => import('@/pages/pointOfSales/salesApp/shipping.vue')

const orderScreensIndex = () => import('@/pages/pointOfSales/ordersScreens/index.vue')
const orderScreensForm = () => import('@/pages/pointOfSales/ordersScreens/form.vue')

const hallsIndex = () => import('@/pages/pointOfSales/halls/index.vue')
const hallsForm = () => import('@/pages/pointOfSales/halls/form.vue')

const routes = [
  {
    path: 'pointOfSales',
    name: 'pointOfSales',
    component: pointOfSalesIndex
  },
  {
    path: 'pointOfSales/create',
    name: 'pointOfSalesCreate',
    component: pointOfSalesForm
  },

  {
    path: 'pointOfSales/:id/edit',
    name: 'pointOfSalesEdit',
    component: pointOfSalesForm
  },
  {
    path: 'pointOfSales/:id',
    name: 'pointOfSalesShow',
    component: pointOfSalesShow
  },
  {
    path: 'pointOfSales/:id/invoices',
    name: 'pointOfSalesInvoicesSingle',
    component: pointOfSalesInvoices
  },
  {
    path: 'pointOfSales/:id/expenses',
    name: 'pointOfSalesExpenses',
    component: pointOfSalesExpenses
  },
  {
    path: 'pointOfSales/:id/shipping',
    name: 'pointOfSalesExpenses',
    component: pointOfSalesShipping
  },
  {
    path: 'pointOfSalesSessions',
    name: 'pointOfSalesSessions',
    component: pointOfSalesSessionIndex
  },
  {
    path: 'pointOfSalesSessions/:id',
    name: 'pointOfSalesSessionsShow',
    component: pointOfSalesSessionShow
  },
  {
    path: 'orderScreens',
    name: 'orderScreens',
    component: orderScreensIndex
  },
  {
    path: 'orderScreens/create',
    name: 'orderScreensCreate',
    component: orderScreensForm
  },
  {
    path: 'orderScreens/:id/edit',
    name: 'orderScreensEdit',
    component: orderScreensForm
  },
  {
    path: 'halls',
    name: 'halls',
    component: hallsIndex
  },
  {
    path: 'halls/create',
    name: 'hallsCreate',
    component: hallsForm
  },
  {
    path: 'halls/:id/edit',
    name: 'hallsEdit',
    component: hallsForm
  }
]

export default routes
